import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "image",
    tabindex: "0"
};
const _hoisted_2 = ["src"];
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'VensoDeliveryImage',
    props: {
        imageUri: {}
    },
    emits: ["remove"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        function removeImage() {
            emit('remove', props.imageUri);
        }
        const imageSrc = computed(() => props.imageUri != null ? props.imageUri.replace("files:", "/files/") : "");
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", { class: "image__meta" }, [
                    _createElementVNode("span", {
                        onClick: removeImage,
                        class: "icon fa fa-times image__remove-icon"
                    })
                ]),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("img", {
                    src: imageSrc.value,
                    alt: ""
                }, null, 8, _hoisted_2)
            ]));
        };
    }
});
